var map = {
	"./en/auth.json": 1272,
	"./en/clients.json": 2586,
	"./en/common.json": 9411,
	"./en/contracts.json": 5909,
	"./en/expenses.json": 763,
	"./en/index.json": 9170,
	"./en/menu.json": 9105,
	"./en/payrolls.json": 9884,
	"./en/planned-expenses.json": 7746,
	"./en/production-calendar.json": 3582,
	"./en/report-company-profit.json": 4155,
	"./en/report-efficiency.json": 2274,
	"./en/report-employees.json": 6172,
	"./en/report-margin.json": 1069,
	"./en/report-wallets-balances.json": 5591,
	"./en/salary.json": 9548,
	"./en/sells.json": 4611,
	"./en/split-expenses.json": 2436,
	"./en/transfer.json": 7069,
	"./en/unallocated.json": 8794,
	"./en/update-data.json": 8870,
	"./en/user-tasks.json": 2942,
	"./en/users.json": 2254,
	"./en/validations.json": 3658,
	"./ru/auth.json": 3978,
	"./ru/clients.json": 5332,
	"./ru/common.json": 7845,
	"./ru/contracts.json": 8971,
	"./ru/expenses.json": 8577,
	"./ru/index.json": 8788,
	"./ru/menu.json": 3807,
	"./ru/payrolls.json": 1498,
	"./ru/planned-expenses.json": 8072,
	"./ru/production-calendar.json": 1100,
	"./ru/report-company-profit.json": 9661,
	"./ru/report-efficiency.json": 8984,
	"./ru/report-employees.json": 2162,
	"./ru/report-margin.json": 9579,
	"./ru/report-wallets-balances.json": 7377,
	"./ru/salary.json": 8014,
	"./ru/sells.json": 3465,
	"./ru/split-expenses.json": 422,
	"./ru/transfer.json": 131,
	"./ru/unallocated.json": 1572,
	"./ru/update-data.json": 900,
	"./ru/user-tasks.json": 6836,
	"./ru/users.json": 5672,
	"./ru/validations.json": 8264
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7802;